import { Typography } from '@design-system/components/typography/typography';
import { faPen, faTrash, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from './VideoUploadStateModal.css';
import { ListItemUploadStatus } from './ListItemUploadStatus';
import React from 'react';
import { UploadVideoVM } from '../../view-models/uploadVideo.viewModel';
import { UploadFile } from '../../models/uploadVideo.model';
import { UploadState } from '../../models/library.domain';
import { clsx } from 'clsx';
import { sprinkles } from '@design-system/sprinkles.css';
import { getFileNameWihoutExtension } from '../../helpers';
import { Tooltip } from '@design-system/components/tooltip/tooltip';

const MemoVideo = React.memo(function ReactHlsPlayer(p: {
  videoSrc: string;
  startTime?: number;
}) {
  const src = p?.startTime ? `${p.videoSrc}#t=${p.startTime}` : p.videoSrc;
  return (
    <video
      src={src}
      className={clsx(
        'max-w-[52px] max-h-[52px]',
        sprinkles({ clipPath: 'sm' }),
      )}
    />
  );
});

export const ListItem = ({
  dispatch,
  index,
  item,
  uploadState,
}: {
  dispatch: UploadVideoVM['dispatch'];
  index: number;
  item: UploadFile;
  uploadState?: UploadState;
}) => {
  return (
    <div className="flex gap-4 w-full justify-between">
      <div className="flex gap-1 w-full">
        <div className="flex justify-center items-center min-w-[68px] min-h-[68px]">
          <MemoVideo
            videoSrc={item.videoSrc}
            startTime={item.thumbnailTimestamp}
          />
        </div>
        <div className="flex flex-col justify-center w-full">
          <Typography>{getFileNameWihoutExtension(item.file.name)}</Typography>
          {!item.error ? null : (
            <Typography color="ERROR-100">{item.error}</Typography>
          )}
          {item.error ? null : (
            <ListItemUploadStatus
              status={uploadState?.state || 'ready'}
              progress={uploadState?.progress}
              edited={!!item?.edited}
              uploadSizeWarning={item.uploadSizeWarning}
            />
          )}
        </div>
      </div>
      {!uploadState && !item.error ? (
        <div className="flex gap-2 items-center">
          <div
            onClick={(ev) => {
              ev.preventDefault();
              ev.stopPropagation();
              dispatch('editFile', index);
            }}
          >
            <Tooltip
              title={
                <div className="px-2 py-1 flex flex-col gap-3">
                  <Typography variant="body" size="small">
                    Edit the file name and thumbnail so that each item makes
                    sense to you.
                  </Typography>{' '}
                  <Typography variant="body" size="small">
                    We suggest making your file name the name of the specific
                    exercise, like "Dumbbell curl".
                  </Typography>
                </div>
              }
              variant="dark"
              tooltipProps={{ width: '220px' }}
              placement="right"
              arrow={true}
            >
              <FontAwesomeIcon icon={faPen} className={icon} />
            </Tooltip>
          </div>
          <FontAwesomeIcon
            icon={faTrash}
            className={icon}
            onClick={() => dispatch('deleteFile', item.file.name)}
          />
        </div>
      ) : null}
      {uploadState?.state === 'uploading' ? (
        <div className="flex gap-2 items-center">
          <FontAwesomeIcon
            icon={faXmark}
            className={icon}
            onClick={() => dispatch('cancelSingleUpload', item.id)}
          />
        </div>
      ) : null}
    </div>
  );
};
